<template>
	<div
		class="d-flex flex-column align-items-center justify-content-center w-100">
		<v-card class="w-100">
			<v-hover
				open-delay="150"
				close-delay="150"
				v-slot="{ isHovering, props }">
				<v-toolbar
					v-bind="props"
					@click="toggleComponentCollapse"
					class="cursor-pointer">
					<v-toolbar-title> Oferte </v-toolbar-title>
					<v-expand-transition>
						<div
							v-if="isHovering"
							class="d-flex justify-content-center align-items-center"
							style="
								background: rgb(
									var(--v-theme-on-surface-variant)
								);
								position: absolute;
								top: 65%;
								left: 50%;
							">
							<v-icon v-if="collapsed"
								>mdi-chevron-double-down</v-icon
							>
							<v-icon v-else>mdi-chevron-double-up</v-icon>
						</div>
					</v-expand-transition>
				</v-toolbar>
			</v-hover>
			<v-expand-transition>
				<v-card-text v-if="!collapsed">
					<v-data-table-server
						:items="sortedItems"
						:headers="headers"
						:items-length="tableItemsLength"
						:page="offersPage"
						:items-per-page="offersItemsPerPage"
						:items-per-page-options="itemsPerPageOptions"
						class="elevation-1"
						:variant="this.$store.state.vuetifyFieldType"
						item-title="title"
						item-value="id"
						:loading="loading"
						dense
						@update:page="onUpdatePage"
						@update:items-per-page="onUpdateItemsPerPage">
						<template v-slot:[`item.offer_id`]="{ item }">
							<a
								href="#"
								class="text-decoration-none"
								@click.prevent="showOfferDetails(item)"
								><span
									v-if="
										differentCreator(
											item.agent
												? item.agent
												: clientAgent,
											clientAgent
										)
									"
									>#{{ item.id
									}}<span class="text-danger">*</span>
									<v-tooltip
										content-class="custom-tooltip"
										activator="parent"
										location="top">
										{{
											differentCreator(
												item.agent,
												clientAgent
											)
										}}
									</v-tooltip></span
								>
								<span v-else>#{{ item.id }}</span>
							</a>
						</template>
						<template v-slot:[`item.modified`]="{ item }">
							{{
								new Date(item.modified).toLocaleString(
									"ro-RO",
									{
										year: "numeric",
										month: "long",
										day: "numeric",
										hour: "numeric",
										minute: "numeric",
										second: "numeric",
									}
								)
							}}
						</template>
						<template v-slot:[`item.dimension`]="{ item }">
							<span
								v-if="
									item.type === 1 ||
									item.type === 3 ||
									item.type === 20
								">
								<v-tooltip
									v-if="getDimensionChangeDescription(item)"
									activator="parent"
									location="top"
									open-delay="250">
									{{ getDimensionChangeDescription(item) }}
								</v-tooltip>
								<v-btn
									color="primary"
									variant="text"
									href="#"
									class="text-decoration-none"
									@click.prevent="openDimensioning(item)">
									{{ getDimensionVersion(item) }}
								</v-btn>
							</span>
							<span v-else>Nu</span>
						</template>
						<template v-slot:[`item.type`]="{ item }">
							<span v-if="item.type === 1">IPA_OLD</span>
							<span v-if="item.type === 2">SANITARE</span>
							<span v-if="item.type === 3">VMC</span>
							<span v-if="item.type === 4"
								>{{
									"SIMPLĂ" +
									(item.custom_pdf_heading
										? " / " + item.custom_pdf_heading
										: "")
								}}</span
							>
							<span v-if="item.type === 5">C. T. și COLOANE</span>
							<span v-if="item.type === 6">TAVAN</span>
							<span v-if="item.type === 7">PEREȚI</span>
							<span v-if="item.type === 8">AUTOMATIZARE</span>
							<span v-if="item.type === 9"
								>VENTILOCONVECTOARE</span
							>
							<span v-if="item.type === 10">CANAL TERMIC</span>
							<span v-if="item.type === 11">PDC</span>
							<span v-if="item.type === 12">ASPIRARE</span>
							<span v-if="item.type === 13">SERVICII</span>
							<span v-if="item.type === 20">
								IPA
								<span
									v-if="item.isComposite"
									class="text-primary">
									[compusă]
								</span>
							</span>
						</template>
						<template v-slot:[`item.total_area`]="{ item }">
							<span
								v-if="
									item.type === 1 ||
									item.type === 3 ||
									item.type === 20
								">
								{{
									item.total_area
										? parseFloat(item.total_area).toFixed(
												2
											) + "m²"
										: "Nu"
								}}
							</span>
							<span
								v-else-if="
									item.type === 6 &&
									ceilingSetupAreas[item.id]
								">
								{{
									parseFloat(
										ceilingSetupAreas[item.id]
									).toFixed(2) + "m²"
								}}
							</span>
							<span v-else>Nu</span>
						</template>
						<template v-slot:[`item.list_price_value`]="{ item }">
							<v-tooltip
								v-if="item.offers?.length"
								activator="parent"
								location="top">
								<template #activator="{ props }">
									<span
										v-bind="props"
										v-if="
											item.total_list_price ||
											item.list_price_value !== '0.00'
										">
										{{
											formatNumber(
												this,
												Math.round(
													item.total_list_price ||
														item.list_price_value ||
														0
												),
												true,
												0
											)
										}}
										compus
									</span>
								</template>
								<div>
									<div
										v-for="sub in item.offers"
										:key="sub.id"
										style="white-space: nowrap">
										#{{ sub.id }} —
										{{
											formatNumber(
												this,
												Math.round(
													sub.list_price_value || 0
												),
												true,
												0
											)
										}}
										lei
									</div>
								</div>
							</v-tooltip>

							<span v-else-if="item.list_price_value !== '0.00'">
								{{
									formatNumber(
										this,
										Math.round(item.list_price_value),
										true,
										0
									)
								}}
							</span>
							<span v-else>--</span>
						</template>
						<template v-slot:[`item.discount`]="{ item }">
							<span v-if="isOfferMixedDiscount(item)">
								<span v-if="resolveOfferDiscountLabel(item)">
									{{ resolveOfferDiscountLabel(item) }}
								</span>
								<span style="color: red"> Mixt</span>
							</span>
							<span
								v-else-if="
									item.discount !== '0.00' &&
									item.discount !== null
								">
								{{ parseInt(item.discount) }}%
							</span>
							<span v-else>--</span>
						</template>
						<template
							v-slot:[`item.value_with_discount`]="{ item }">
							<v-tooltip
								v-if="item.offers?.length"
								activator="parent"
								location="top">
								<template #activator="{ props }">
									<span
										v-bind="props"
										v-if="
											item.total_with_discount ||
											item.value_with_discount !== '0.00'
										">
										{{
											formatNumber(
												this,
												Math.round(
													item.total_with_discount ||
														item.value_with_discount ||
														0
												),
												true,
												0
											)
										}}
										compus
									</span>
								</template>
								<div>
									<div
										v-for="sub in item.offers"
										:key="sub.id"
										style="white-space: nowrap">
										#{{ sub.id }} —
										{{
											formatNumber(
												this,
												Math.round(
													sub.value_with_discount || 0
												),
												true,
												0
											)
										}}
										lei
									</div>
								</div>
							</v-tooltip>

							<span
								v-else-if="item.value_with_discount !== '0.00'">
								{{
									formatNumber(
										this,
										Math.round(item.value_with_discount),
										true,
										0
									)
								}}
							</span>
							<span v-else>--</span>
						</template>
						<template v-slot:[`item.notes`]="{ item }">
							<v-tooltip
								v-if="getOfferNotes(item)"
								location="top">
								<template #activator="{ props }">
									<v-icon
										v-bind="props"
										size="small"
										color="primary">
										mdi-note-text-outline
									</v-icon>
								</template>
								<div
									style="
										max-width: 320px;
										white-space: pre-wrap;
										word-break: break-word;
									">
									{{ getOfferNotes(item) }}
								</div>
							</v-tooltip>
							<span v-else>--</span>
						</template>
						<template v-slot:[`item.actions`]="{ item }">
							<v-btn icon >
								<v-icon color="grey">mdi-dots-vertical</v-icon>
								<v-menu activator="parent" close-on-content-click>
									<v-list density="compact">
										<template
											v-for="(action, index) in getActionMenuItems(
												item
											)"
											:key="index">
											<v-divider
												v-if="action.isDivider" />
											<v-list-item
												v-else
												@click="action.method()">
												<v-list-item-title
													:class="{
														'text-danger':
															action.isDanger,
													}">
													{{ action.label }}
												</v-list-item-title>
											</v-list-item>
										</template>
									</v-list>
								</v-menu>
							</v-btn>
						</template>
					</v-data-table-server>
				</v-card-text>
			</v-expand-transition>
		</v-card>

		<v-dialog v-model="deleteDialog" width="auto">
			<v-card>
				<v-card-title
					class="text-danger d-flex align-items-center justify-content-between">
					Atenție!
					<v-icon color="danger">mdi-alert-octagon-outline</v-icon>
				</v-card-title>
				<v-card-text>
					Această operație nu este reversibilă. Datele vor fi șterse
					permanent. <br />
					Ești sigur că dorești să ștergi aceste date?
				</v-card-text>
				<v-card-actions class="justify-content-end">
					<v-btn
						color="primary"
						variant="text"
						@click="deleteDialog = false">
						Nu
					</v-btn>
					<v-btn
						color="danger"
						variant="text"
						@click="deleteOffer(offerToDelete)">
						Da
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="showSubofferMenu"
			max-width="500"
			scrollable
			@update:model-value="
				v => {
					if (!v) resetPdfSelection();
				}
			">
			<v-card variant="elevated" class="mt-4" style="max-height: 65vh">
				<v-toolbar>
					<v-toolbar-title>
						Generare PDF pentru ofertă - #{{ pdfOffer?.id }}
					</v-toolbar-title>
				</v-toolbar>

				<v-card-text scrollable style="max-height: 500px">
					<v-list density="compact">
						<div
							class="d-flex justify-space-between py-1 pl-4 pr-2">
							<v-btn
								variant="elevated"
								size="small"
								:disabled="!pdfSuboffers.length"
								@click="toggleSelectAllSuboffers">
								{{
									isAllSuboffersSelected
										? "deselecteaza toate subofertele"
										: "selecteaza toate subofertele"
								}}
							</v-btn>
						</div>

						<v-list-item class="py-1" @click="toggleTotal">
							<template #prepend>
								<v-checkbox
									v-model="selectTotal"
									density="compact"
									color="secondary"
									class="mr-2"
									hide-details
									@click.stop="toggleTotal" />
							</template>
							<v-list-item-title>
								Generează OFERTA TOTALĂ
							</v-list-item-title>
						</v-list-item>

						<v-list-item
							v-for="sub in pdfSuboffers"
							:key="sub.id"
							class="py-1"
							@click="toggleSuboffer(sub.id)">
							<template #prepend>
								<v-checkbox
									v-model="selectedSuboffers"
									:value="sub.id"
									density="compact"
									color="secondary"
									class="mr-2"
									hide-details
									@click.stop="selectTotal = false" />
							</template>
							<v-list-item-title
								class="d-flex align-center gap-2">
								#{{ sub.id }}
								<span class="text-caption">
									·
									<strong>{{
										getSubofferUnitLabel(sub)
									}}</strong>
								</span>
							</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-card-text>

				<v-card-actions class="d-flex justify-space-between pa-4">
					<v-btn text @click="resetPdfSelection">Închide</v-btn>
					<v-btn
						color="#54c5b0"
						variant="elevated"
						:disabled="
							!selectTotal && selectedSuboffers.length === 0
						"
						@click="generateCompositePDF">
						{{
							selectTotal
								? "Generează PDF"
								: selectedSuboffers.length > 1
									? "Generează ZIP"
									: "Generează PDF"
						}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="discountDialog" max-width="480" persistent>
			<v-card>
				<v-card-title class="d-flex align-center justify-space-between">
					Discount general
					<span class="text-caption text-medium-emphasis">
						#{{ discountEditOffer?.id }}
					</span>
				</v-card-title>
				<v-card-text>
					<v-alert
						v-if="discountApplyAllWarning"
						type="warning"
						variant="tonal"
						density="compact"
						class="mb-4">
						{{ discountApplyAllWarning }}
					</v-alert>
					<v-text-field
						v-model="discountEditValue"
						variant="outlined"
						label="Discount (%)"
						type="number"
						min="0"
						max="100"
						step="1"
						suffix="%"
						:error-messages="discountEditError"
						:disabled="discountSaving"
						hide-details="auto"
						@keyup.enter="submitGeneralDiscount" />
				</v-card-text>
				<v-card-actions class="justify-end pa-4">
					<v-btn
						variant="text"
						:disabled="discountSaving"
						@click="closeGeneralDiscountDialog">
						Anulează
					</v-btn>
					<v-btn
						color="#54c5b0"
						variant="elevated"
						:loading="discountSaving"
						:disabled="!canSubmitGeneralDiscount"
						@click="submitGeneralDiscount">
						Salvează
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import {
	checkForUpdates,
	createPDFCompositeOffer,
	createPDFCompositeOffersZip,
	createPDFCompositeTotalOffer,
	createPDFDimensioning,
	createPDFOfferJob,
	formatNumber,
	showAlertModal,
	updateOfferGeneralDiscount,
} from "@/utils/utils";
import apiClient from "@/utils/apiClient";

export default {
	name: "OffersCard",
	components: {},
	emits: ["offers-fetched", "location-offers-fetched"],
	props: {
		searchBy: Object,
		clientId: {
			type: String,
			default: null,
		},
		searchId: Number,
		clientOffersData: {
			type: Array,
			default: () => [],
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		clientAgent: {
			type: Number,
			default: null,
		},
		searchOfferType: {
			type: Number,
		},
	},
	data() {
		return {
			fetchedClientOffers: [],
			searchString: "",
			isCollapsed: this.collapsed,
			showOffersButton: false,
			collapsed: true,
			sortKey: null,
			ceilingSetupAreas: {},
			sortDirection: 1,
			headers: [
				{
					title: "Nr.",
					key: "offer_id",
					align: "center",
					sortable: true,
				},
				{
					title: "Data",
					key: "modified",
					align: "center",
					sortable: true,
				},
				{
					title: "Dim.",
					key: "dimension",
					align: "center",
					sortable: true,
				},
				{ title: "Tip", key: "type", align: "center", sortable: true },
				{
					title: "Suprafață",
					key: "total_area",
					align: "center",
					sortable: true,
				},
				{
					title: "Total preț listă",
					key: "list_price_value",
					align: "center",
					sortable: true,
					width: "120px",
				},
				{
					title: "Discount",
					key: "discount",
					align: "center",
					sortable: true,
				},
				{
					title: "Total cu discount",
					key: "value_with_discount",
					align: "center",
					sortable: true,
					width: "120px",
				},
				{
					title: "Observații",
					key: "notes",
					align: "center",
					sortable: false,
				},
				{
					title: "Acțiuni",
					key: "actions",
					align: "center",
					sortable: false,
				},
			],
			deleteDialog: false,
			showSubofferMenu: false,
			pdfOffer: null,
			pdfType: 0,
			selectedSuboffers: [],
			selectTotal: false,
			loading: false,
			offerToDelete: null,
			useServerPagination: false,
			offersPage: 1,
			offersItemsPerPage: 10,
			offersTotal: 0,
			itemsPerPageOptions: [10, 25, 50],
			discountDialog: false,
			discountEditOffer: null,
			discountEditValue: "",
			discountEditError: "",
			discountSaving: false,
		};
	},
	computed: {
		discountApplyAllWarning() {
			const offer = this.discountEditOffer;
			if (!offer) return "";

			const isComposite = this.isCompositeOffer(offer);
			const isMixed = this.isOfferMixedDiscount(offer);
			const unitCount = offer.offers?.length || 0;

			if (isComposite && isMixed) {
				return unitCount > 1
					? `Oferta compusă are discount mixt. Noul discount va fi aplicat tuturor celor ${unitCount} unități și tuturor produselor discountabile.`
					: "Oferta compusă are discount mixt. Noul discount va fi aplicat tuturor produselor discountabile.";
			}
			if (isComposite) {
				return unitCount > 1
					? `Discountul va fi aplicat tuturor celor ${unitCount} unități din oferta compusă.`
					: "Discountul va fi aplicat întregii oferte compuse.";
			}
			if (isMixed) {
				return "Oferta are discount mixt. Noul discount general va înlocui discounturile individuale ale produselor.";
			}
			return "";
		},
		canSubmitGeneralDiscount() {
			if (this.discountSaving || this.discountEditError) return false;
			return this.discountEditValue !== "" && this.discountEditValue !== null;
		},
		tableItems() {
			if (this.useServerPagination) {
				return this.fetchedClientOffers;
			}
			const start = (this.offersPage - 1) * this.offersItemsPerPage;
			return this.fetchedClientOffers.slice(
				start,
				start + this.offersItemsPerPage
			);
		},
		tableItemsLength() {
			if (this.useServerPagination) {
				return this.offersTotal;
			}
			return this.fetchedClientOffers.length;
		},
		sortedItems() {
			const items = this.tableItems.slice();
			if (this.sortKey) {
				items.sort((a, b) => {
					const valueA = this.getPropertyValue(a, this.sortKey);
					const valueB = this.getPropertyValue(b, this.sortKey);

					if (valueA === null) return 1;
					if (valueB === null) return -1;

					if (valueA > valueB) return this.sortDirection;
					if (valueA < valueB) return -this.sortDirection;

					return 0;
				});
			}
			return items;
		},
		pdfSuboffers() {
			if (!this.pdfOffer?.offers?.length) return [];
			return [...this.pdfOffer.offers].sort((a, b) => a.id - b.id);
		},
		isAllSuboffersSelected() {
			return (
				this.selectedSuboffers.length === this.pdfSuboffers.length &&
				this.pdfSuboffers.length > 0
			);
		},
	},
	methods: {
		getOfferNotes(offer) {
			const mainNotes = offer?.notes?.trim?.() || "";
			if (mainNotes) return mainNotes;

			if (!offer?.offers?.length) return "";

			const subNotes = offer.offers
				.filter(sub => sub?.notes?.trim?.())
				.map(sub => `#${sub.id}: ${sub.notes.trim()}`);

			return subNotes.join("\n");
		},
		getDimensionVersion(offer) {
			return (
				offer?.offer_location_version ||
				offer?.location?.version ||
				offer?.location_data?.version ||
				(offer?.offers?.length
					? offer.offers[0]?.offer_location_version
					: "")
			);
		},
		getDimensionChangeDescription(offer) {
			const description = [
				offer?.location?.change_description,
				offer?.location_data?.change_description,
				offer?.change_description,
				offer?.offer_location_change_description,
			].find(value => typeof value === "string" && value.trim());

			return description?.trim?.() || "";
		},
		resolveOfferDiscountLabel(offer) {
			// Mixed offers may have per-product discounts; only show the stored
			// offer-level discount, never an effective % derived from totals.
			const directDiscount = parseFloat(offer?.discount);
			if (!isNaN(directDiscount) && directDiscount > 0) {
				return `${parseInt(directDiscount)}%`;
			}

			return null;
		},
		isCompositeOffer(offer) {
			return String(offer?.id ?? "").toUpperCase().startsWith("CO");
		},
		getGeneralDiscountInitialValue(offer) {
			const directDiscount = parseFloat(offer?.discount);
			if (!isNaN(directDiscount) && directDiscount >= 0) {
				return String(parseInt(directDiscount));
			}
			return "0";
		},
		validateDiscountEditValue() {
			const raw = String(this.discountEditValue ?? "").trim().replace(",", ".");
			if (raw === "") {
				this.discountEditError = "Introduceți un discount.";
				return null;
			}
			const parsed = parseFloat(raw);
			if (isNaN(parsed)) {
				this.discountEditError = "Discountul trebuie să fie un număr.";
				return null;
			}
			if (parsed < 0 || parsed > 100) {
				this.discountEditError = "Discountul trebuie să fie între 0 și 100.";
				return null;
			}
			this.discountEditError = "";
			return Math.round(parsed * 100) / 100;
		},
		openGeneralDiscountDialog(offer) {
			this.discountEditOffer = offer;
			this.discountEditValue = this.getGeneralDiscountInitialValue(offer);
			this.discountEditError = "";
			this.discountDialog = true;
		},
		closeGeneralDiscountDialog() {
			this.discountDialog = false;
			this.discountEditOffer = null;
			this.discountEditValue = "";
			this.discountEditError = "";
			this.discountSaving = false;
		},
		applyGeneralDiscountResultToList(result) {
			if (!result?.offer_id) return;

			const offerId = result.offer_id;
			const index = this.fetchedClientOffers.findIndex(
				offer => String(offer.id) === String(offerId)
			);
			if (index < 0) return;

			const current = this.fetchedClientOffers[index];
			const updated = {
				...current,
				discount: String(result.discount ?? current.discount ?? 0),
				list_price_value:
					result.list_price_value ?? current.list_price_value,
				value_with_discount:
					result.value_with_discount ?? current.value_with_discount,
				total_list_price:
					result.total_list_price ?? current.total_list_price,
				total_with_discount:
					result.total_with_discount ?? current.total_with_discount,
				is_discount_mixed: Boolean(result.is_discount_mixed),
			};

			if (Array.isArray(result.offers) && Array.isArray(current.offers)) {
				updated.offers = current.offers.map(sub => {
					const subResult = result.offers.find(
						item => Number(item.id) === Number(sub.id)
					);
					if (!subResult) return sub;
					return {
						...sub,
						discount: String(subResult.discount ?? sub.discount ?? 0),
						list_price_value:
							subResult.list_price_value ?? sub.list_price_value,
						value_with_discount:
							subResult.value_with_discount ?? sub.value_with_discount,
					};
				});
			}

			const nextList = [...this.fetchedClientOffers];
			nextList[index] = updated;
			this.fetchedClientOffers = this.normalizeOffersList(nextList);
			this.$emit("location-offers-fetched", this.fetchedClientOffers);
		},
		async submitGeneralDiscount() {
			const discount = this.validateDiscountEditValue();
			if (discount === null || !this.discountEditOffer) return;

			this.discountSaving = true;
			try {
				const result = await updateOfferGeneralDiscount(
					this.discountEditOffer.id,
					discount
				);

				if (this.useServerPagination || this.searchString) {
					await this.fetchClientOffers(
						this.offersPage,
						this.offersItemsPerPage
					);
				} else {
					this.applyGeneralDiscountResultToList(result);
				}

				showAlertModal(
					this.$store,
					"Discountul general a fost actualizat cu succes.",
					"success",
					2500
				);
				this.closeGeneralDiscountDialog();
			} catch (error) {
				console.error(
					"Error updating general discount:",
					error.response ? error.response.data : error.message
				);
				showAlertModal(
					this.$store,
					"A apărut o eroare la actualizarea discountului.",
					"danger",
					6000,
					error
				);
			} finally {
				this.discountSaving = false;
			}
		},
		parseMixedDiscountFlag(value) {
			if (value === true || value === 1 || value === "1") return true;
			if (typeof value === "string") {
				return value.trim().toLowerCase() === "true";
			}
			return false;
		},
		isOfferMixedDiscount(offer) {
			const mixedFlag = this.parseMixedDiscountFlag(offer?.is_discount_mixed);
			if (mixedFlag) return true;

			const listPrice = parseFloat(
				offer?.total_list_price ?? offer?.list_price_value ?? 0
			);
			const discountedPrice = parseFloat(
				offer?.total_with_discount ?? offer?.value_with_discount ?? 0
			);
			const generalDiscount = parseFloat(offer?.discount);

			// Product-level discounts can exist without a general offer discount.
			// In that case, treat it as mixed only when total-with-discount is lower than list total.
			if (
				listPrice > 0 &&
				!isNaN(discountedPrice) &&
				(isNaN(generalDiscount) || generalDiscount <= 0)
			) {
				return discountedPrice < listPrice - 0.01;
			}

			// When a general discount is set, trust the backend flag.
			// Do not infer "Mixt" from totals: excluded products (e.g. Timbru verde)
			// at full price make the effective % differ from the nominal discount
			// even when every discountable line uses the same general discount.
			return false;
		},
		normalizeOffersList(offersList = []) {
			let list = JSON.parse(JSON.stringify(offersList || []));

			list = list.map(offer => {
				if (offer.offers && offer.offers.length > 0) {
					const totalList = offer.offers.reduce(
						(acc, sub) => acc + parseFloat(sub.list_price_value || 0),
						0
					);
					const totalWithDiscount = offer.offers.reduce(
						(acc, sub) =>
							acc + parseFloat(sub.value_with_discount || 0),
						0
					);
					offer.total_list_price = totalList.toFixed(2);
					offer.total_with_discount = totalWithDiscount.toFixed(2);
					// Keep the "single offer" fields consistent too, since the template
					// sometimes falls back between `total_with_discount` and `value_with_discount`.
					offer.list_price_value = offer.total_list_price;
					offer.value_with_discount = offer.total_with_discount;
				}

				// Some APIs return canonical totals as camelCase/snake_case fields;
				// prefer them when present to keep mixed discounts accurate.
				const canonicalListPrice = parseFloat(
					offer.totalPriceWithoutDiscount ??
						offer.total_price_without_discount ??
						offer.total_list_price ??
						offer.list_price_value ??
						0
				);
				const canonicalDiscountedPrice = parseFloat(
					offer.totalFinalPrice ??
						offer.total_final_price ??
						offer.total_with_discount ??
						offer.value_with_discount ??
						0
				);
				if (Number.isFinite(canonicalListPrice) && canonicalListPrice >= 0) {
					offer.total_list_price = canonicalListPrice.toFixed(2);
					offer.list_price_value = offer.total_list_price;
				}
				if (
					Number.isFinite(canonicalDiscountedPrice) &&
					canonicalDiscountedPrice >= 0
				) {
					offer.total_with_discount = canonicalDiscountedPrice.toFixed(2);
					offer.value_with_discount = offer.total_with_discount;
				}

				const listPrice = parseFloat(
					offer.total_list_price ??
						offer.list_price_value ??
						0
				);
				const discountedPrice = parseFloat(
					offer.total_with_discount ??
						offer.value_with_discount ??
						0
				);

				const rawMixedFlag = this.parseMixedDiscountFlag(
					offer?.is_discount_mixed
				);

				const discountPercent = parseFloat(offer.discount);
				const hasMixedDiscount = rawMixedFlag || this.isOfferMixedDiscount(offer);
				const offerType = Number(offer?.type);
				const hasDiscount =
					discountPercent !== null &&
					!isNaN(discountPercent) &&
					discountPercent > 0 &&
					!hasMixedDiscount;

				// For IPA offers, totals can include non-discountable/category-specific rules.
				// In that case backend totals are authoritative; avoid deriving totals from %.
				if (hasDiscount && listPrice > 0 && offerType !== 20 && offerType !== 1) {
					const expectedDiscountedTotal = (
						listPrice *
						(1 - discountPercent / 100)
					).toFixed(2);
					const expected = parseFloat(expectedDiscountedTotal);
					// Recompute only when stored total looks stale (missing, zero, or discount
					// not applied). Do not overwrite when backend total is higher than the simple
					// formula — that indicates non-discountable products at full price.
					const shouldRecompute =
						isNaN(discountedPrice) ||
						discountedPrice <= 0 ||
						Math.abs(discountedPrice - listPrice) < 0.01 ||
						discountedPrice < expected - 0.01;

					if (shouldRecompute) {
						offer.value_with_discount = expectedDiscountedTotal;
						offer.total_with_discount = expectedDiscountedTotal;
					}
				}

				return offer;
			});

			list = list.map(offer => {
				const offerType = Number(offer?.type);
				if (
					offerType === 20 &&
					Array.isArray(offer.offers) &&
					offer.offers.length
				) {
					const discounts = offer.offers.map(sub => {
						const subList = parseFloat(sub.list_price_value || 0);
						const subDisc = parseFloat(sub.value_with_discount || 0);
						if (subList > 0 && subDisc > 0) {
							const computed = 100 - (subDisc / subList) * 100;
							return parseFloat(computed.toFixed(2));
						}
						return 0;
					});
					const unique = [...new Set(discounts.map(d => d.toFixed(2)))];
					offer.is_discount_mixed = unique.length > 1;
					// Keep backend-provided `offer.discount` (it comes from sub-offers' stored discount).
					// Only fill it here if it's missing, to avoid overwriting correct data with
					// potentially stale `value_with_discount`-derived computations.
					if (
						offer.discount === undefined ||
						offer.discount === null ||
						offer.discount === "0.00" ||
						offer.discount === 0
					) {
						offer.discount = unique.length === 1 ? unique[0] : null;
					}
					offer.sub_discounts = discounts;
				}
				return offer;
			});

			// Final pass: now that `offer.discount` is available for composite offers,
			// recompute totals again to guarantee consistency.
			list = list.map(offer => {
				const listPrice = parseFloat(
					offer.total_list_price ??
						offer.list_price_value ??
						0
				);
				const discountedPrice = parseFloat(
					offer.total_with_discount ??
						offer.value_with_discount ??
						0
				);
				const rawMixedFlag = this.parseMixedDiscountFlag(
					offer?.is_discount_mixed
				);
				const discountPercent = parseFloat(offer.discount);
				const hasMixedDiscount =
					rawMixedFlag || this.isOfferMixedDiscount(offer);
				const offerType = Number(offer?.type);

				const hasDiscount =
					discountPercent !== null &&
					!isNaN(discountPercent) &&
					discountPercent > 0 &&
					!hasMixedDiscount;

				if (!hasDiscount || listPrice <= 0 || offerType === 20 || offerType === 1) return offer;

				const expectedDiscountedTotal = (
					listPrice *
					(1 - discountPercent / 100)
				).toFixed(2);
				const expected = parseFloat(expectedDiscountedTotal);

				const shouldRecompute =
					isNaN(discountedPrice) ||
					discountedPrice <= 0 ||
					Math.abs(discountedPrice - listPrice) < 0.01 ||
					discountedPrice < expected - 0.01;

				if (shouldRecompute) {
					offer.value_with_discount = expectedDiscountedTotal;
					offer.total_with_discount = expectedDiscountedTotal;
					offer.total_list_price = listPrice.toFixed(2);
					offer.list_price_value = offer.total_list_price;
				}

				return offer;
			});

			if (list.length > 0) {
				const allSubOfferIds = list
					.filter(o => o.offers?.length)
					.flatMap(o => o.offers.map(s => s.id));

				list = list.filter(
					offer => !offer.composite_offer_id && !allSubOfferIds.includes(offer.id)
				);

				list.forEach(offer => {
					if (offer.hasOffers || offer.offersCount > 0) {
						offer.isComposite = true;
					}
				});
				list.forEach(offer => {
					if (offer.offers?.length) {
						offer.isComposite = true;
					}
				});

				if (this.searchOfferType) {
					list = list.filter(offer => offer.type === this.searchOfferType);
				}

				list.sort((a, b) => b.id - a.id);
			}

			return list;
		},
		/**
		 * Toggles the collapsed state of the OffersCard component.
		 * If expanded, fetches offers data based on the `searchBy` criteria and updates the local state.
		 * This method also filters offers by type if `searchOfferType` is defined.
		 *
		 * @async
		 * @function toggleComponentCollapse
		 * @returns {Promise<void>} Updates the `fetchedClientOffers` and `collapsed` state.
		 */
		async toggleComponentCollapse() {
			this.collapsed = !this.collapsed;
			if (!this.collapsed) {
				this.searchString = "";
				if (this.searchBy.criteria === "location") {
					this.searchString = "_by_location_id";
				} else if (this.searchBy.criteria === "client") {
					this.searchString = "_by_client_id";
				}
				if (this.clientOffersData && this.clientOffersData.length > 0) {
					this.useServerPagination = false;
					this.offersPage = 1;
					this.fetchedClientOffers = this.normalizeOffersList(
						this.clientOffersData
					);
				} else if (
					this.searchBy.value &&
					!(this.clientOffersData && this.clientOffersData.length > 0)
				) {
					this.useServerPagination = true;
					this.offersPage = 1;
					await this.fetchClientOffers(1, this.offersItemsPerPage);
				} else if (this.fetchedClientOffers.length > 0) {
					const ceilingOffers = this.fetchedClientOffers.filter(
						offer => offer.type === 6
					);
					if (ceilingOffers.length > 0) {
						await Promise.all(
							ceilingOffers.map(offer =>
								this.setCeilingArea(offer.id)
							)
						);
					}
				}
			}
		},
		formatNumber,
		/**
		 * Checks if the creator of the offer is different from the client's assigned agent.
		 *
		 * @param {number} offerAgent - The agent ID associated with the offer.
		 * @param {number} clientAgent - The agent ID assigned to the client.
		 * @returns {string|null} Returns a message string if the creators are different, or `null` otherwise.
		 */
		differentCreator(offerAgent, clientAgent) {
			if (clientAgent !== offerAgent) {
				let usersNames = JSON.parse(sessionStorage.getItem("myUsers"));
				let agent_name = usersNames.find(
					user => user.id === offerAgent
				);
				let string = "Oferta a fost creată de ";
				string += agent_name.full_name
					? agent_name.full_name
					: agent_name.email;
				return string;
			}
			return null;
		},
		/**
		 * Toggles the visibility of the delete confirmation dialog and sets the current offer to be deleted.
		 * This method is intended to be called when a user initiates the delete action by clicking the delete
		 * icon associated with an offer. It updates the component's state to reflect the offer selected for deletion
		 * and toggles the visibility of a confirmation dialog.
		 *
		 * @param {Object} offer - The offer object that is intended to be deleted. This object should
		 * contain at least an identifier (id) that uniquely identifies the offer within the dataset.
		 */
		triggerDeleteDialog(offer) {
			this.offerToDelete = offer;
			this.deleteDialog = true;
		},
		getActionMenuItems(offer) {
			const pdfItems = this.getPdfMenuItems(offer);
			const items = pdfItems.map(item => ({
				label: item.label,
				method: item.method,
			}));
			if (items.length) {
				items.push({ isDivider: true });
			}
			items.push({
				label: "Editează discount general",
				method: () => this.openGeneralDiscountDialog(offer),
			});
			items.push({ isDivider: true });
			items.push({
				label: "Șterge",
				method: () => this.triggerDeleteDialog(offer),
				isDanger: true,
			});
			return items;
		},
		getPdfMenuItems(offer) {
			const offerType = Number(offer?.type);
			const items = [
				{
					label: "Ofertă cu preț",
					method: () => this.handlePdfAction(offer, 0),
				},
				{
					label: "Ofertă fără preț",
					method: () => this.handlePdfAction(offer, 1),
				},
				{
					label: "Ofertă fără preț și cantitate",
					method: () => this.handlePdfAction(offer, 3),
				},
			];

			if (offerType === 3 || offerType === 1 || offerType === 20) {
				items.push({
					label: "Ofertă generală",
					method: () => this.handlePdfAction(offer, 2),
				});
				items.push({
					label: "Dimensionare",
					method: () =>
						createPDFDimensioning(
							offer.id,
							this.resolveLocationId(offer),
							0
						),
				});
			}

			return items;
		},
		getPdfContext(offer) {
			const location =
				offer?.location?.id != null
					? offer.location
					: offer?.location_data?.id != null
						? offer.location_data
						: { id: offer?.location };
			return {
				$store: this.$store,
				offerId: offer.id,
				offer,
				location,
				locationId: this.resolveLocationId(offer),
				offerInformation: {
					locationVisibleOnPdf: Boolean(
						offer.location_visible_on_pdf
					),
					areaVisibleOnPdf: Boolean(offer.area_visible_on_pdf),
				},
			};
		},
		resolveLocationId(offer) {
			return (
				offer?.location?.id ||
				offer?.location_data?.id ||
				offer?.location ||
				offer?.location_id
			);
		},
		handlePdfAction(offer, pdfType) {
			const hasSuboffers =
				Array.isArray(offer?.offers) && offer.offers.length > 0;
			if (hasSuboffers) {
				this.pdfOffer = offer;
				this.pdfType = pdfType;
				this.selectedSuboffers = [];
				this.selectTotal = false;
				this.showSubofferMenu = true;
				return;
			}
			createPDFOfferJob(
				offer.id,
				pdfType,
				0,
				this.getPdfContext(offer)
			);
		},
		getSubofferUnitLabel(suboffer) {
			if (!this.pdfOffer?.subdivisions?.length) return "General";
			const index = this.pdfSuboffers.findIndex(o => o.id === suboffer.id);
			return this.pdfOffer.subdivisions[index]?.label || "General";
		},
		toggleTotal() {
			this.selectTotal = !this.selectTotal;
			if (this.selectTotal) {
				this.selectedSuboffers = [];
			}
		},
		toggleSuboffer(subofferId) {
			this.selectTotal = false;
			const index = this.selectedSuboffers.indexOf(subofferId);
			if (index === -1) {
				this.selectedSuboffers.push(subofferId);
			} else {
				this.selectedSuboffers.splice(index, 1);
			}
		},
		toggleSelectAllSuboffers() {
			this.selectTotal = false;
			if (this.isAllSuboffersSelected) {
				this.selectedSuboffers = [];
			} else {
				this.selectedSuboffers = this.pdfSuboffers.map(s => s.id);
			}
		},
		resetPdfSelection() {
			this.showSubofferMenu = false;
			this.pdfOffer = null;
			this.selectedSuboffers = [];
			this.selectTotal = false;
		},
		generateCompositePDF() {
			const offer = this.pdfOffer;
			if (!offer) return;

			const doTotal = this.selectTotal;
			const subs = [...this.selectedSuboffers];
			const sorted = this.pdfSuboffers;
			const compositeId = offer.id;
			const numericCompositeId = compositeId
				? Number(String(compositeId).replace(/^CO/, ""))
				: null;
			const context = this.getPdfContext(offer);

			this.showSubofferMenu = false;

			this.$nextTick(() => {
				setTimeout(() => {
					if (doTotal && numericCompositeId) {
						createPDFCompositeTotalOffer(
							numericCompositeId,
							this.pdfType,
							0,
							context
						);
					}

					if (subs.length > 1) {
						createPDFCompositeOffersZip(
							compositeId,
							subs,
							this.pdfType,
							0,
							context
						);
					} else {
						for (const id of subs) {
							const sub = sorted.find(o => o.id === id);
							if (!sub) continue;

							const unitLabel = this.getSubofferUnitLabel(sub);
							const total = sorted.length;
							const index = sorted.findIndex(o => o.id === id) + 1;

							createPDFCompositeOffer(
								id,
								this.pdfType,
								0,
								unitLabel,
								compositeId,
								index,
								total,
								context
							);
						}
					}

					this.resetPdfSelection();
				}, 30);
			});
		},
		/**
		 * Sorts the fetched offers based on the provided key.
		 * If the same key is clicked again, the sort direction toggles between ascending and descending.
		 *
		 * @param {string} key - The key by which to sort the offers.
		 */
		sortBy(key) {
			if (this.sortKey === key) {
				this.sortDirection *= -1; // Reverse the sort direction if the same key is clicked again
			} else {
				this.sortKey = key;
				this.sortDirection = 1; // Default to ascending order
			}
		},
		/**
		 * Retrieves the value of a nested property from an object using a dot-separated key string.
		 *
		 * @param {Object} item - The object to retrieve the value from.
		 * @param {string} key - The dot-separated key string representing the property path.
		 * @returns {any} The value of the specified property, or `0` if the property is `null` or `undefined`.
		 */
		getPropertyValue(item, key) {
			const keys = key.split(".");
			let value = item;

			for (const k of keys) {
				value = value[k];
				if (value === undefined || value === null) {
					// Return a placeholder value for null values
					return 0;
				}
			}

			return value;
		},
		lastModified(offer) {
			return (
				"Ultima modificare: " +
				new Date(offer.modified).toLocaleDateString("ro-RO")
			);
		},
		onUpdatePage(page) {
			this.offersPage = page;
			if (this.useServerPagination) {
				this.fetchClientOffers(page, this.offersItemsPerPage);
			}
		},
		onUpdateItemsPerPage(itemsPerPage) {
			this.offersItemsPerPage = itemsPerPage;
			this.offersPage = 1;
			if (this.useServerPagination) {
				this.fetchClientOffers(1, itemsPerPage);
			}
		},
		/**
		 * Fetches client offers (one page when using server pagination, or all when not).
		 *
		 * @param {number} page - Page number (1-based). Used only when useServerPagination.
		 * @param {number} itemsPerPage - Page size. Used only when useServerPagination.
		 */
		async fetchClientOffers(page = 1, itemsPerPage = 10) {
			this.loading = true;
			try {
				const offset = this.useServerPagination
					? (page - 1) * itemsPerPage
					: 0;
				const limit = this.useServerPagination
					? itemsPerPage
					: undefined;
				const params = { list: 1 };
				if (limit != null) {
					params.limit = limit;
					params.offset = offset;
				}
				const response = await apiClient.get(
					`/api/get_offer_data${this.searchString}/${this.searchBy.value}/`,
					{ params }
				);

				let allOffers = response.data.offers || [];
				const compositeOffers = response.data.composite_offers || [];

				let list = [
					...JSON.parse(JSON.stringify(allOffers)),
					...JSON.parse(JSON.stringify(compositeOffers)),
				];
				list = this.normalizeOffersList(list);

				this.fetchedClientOffers = list;

				if (this.useServerPagination) {
					const total = response.data.total;
					this.offersTotal =
						typeof total === "number" ? total : list.length;
				}

				if (this.fetchedClientOffers.length > 0) {
					this.$emit(
						"location-offers-fetched",
						this.fetchedClientOffers
					);

					const ceilingOffers = this.fetchedClientOffers.filter(
						o => o.type === 6
					);
					if (ceilingOffers.length > 0) {
						Promise.all(
							ceilingOffers.map(offer =>
								this.setCeilingArea(offer.id)
							)
						);
					}
				} else if (!this.useServerPagination || this.offersPage === 1) {
					this.$emit("offers-fetched", false);
				}
			} catch (error) {
				console.error(
					"Error fetching client offers:",
					error.response ? error.response.data : error.message
				);
				showAlertModal(
					this.$store,
					"A apărut o eroare la încărcarea ofertelor. Vă rugăm să încercați din nou.",
					"danger",
					12000,
					error
				);
			} finally {
				this.loading = false;
			}
		},

		/**
		 * Asynchronously deletes an offer from the server and updates the local state to reflect this change.
		 * This method sends a DELETE request to the server targeting a specific offer by its ID. Upon successful
		 * deletion, it filters out the deleted offer from the local list of fetched client offers. It also manages
		 * loading state indicators and handles any errors that might occur during the process by logging the error
		 * and displaying an alert modal. A success message is displayed in an alert modal after the offer is
		 * successfully deleted.
		 *
		 * @param {Object} offer - The offer object to be deleted. This object must include an `id` property
		 * that uniquely identifies the offer.
		 * @returns {Promise<void>} A promise that resolves when the deletion process has completed. This includes
		 * updating the local state and handling any errors. It does not return a value.
		 * @throws {Error} Throws an error if the deletion request to the server fails. The error is logged to the console
		 * and a warning message is displayed to the user via an alert modal.
		 */
		async deleteOffer(offer) {
			this.loading = true;
			try {
				// Composite offers always have id "CO{pk}" from API; use that instead of offer.offers?.length
				// so composite offers with zero sub-offers still use delete_composite_offer
				const isComposite = String(offer.id).startsWith("CO");
				if (isComposite) {
					const compositePk = String(offer.id).replace(/^CO/, "");
					await apiClient.delete(
						`/api/delete_composite_offer/${compositePk}/`
					);
				} else {
					await apiClient.delete(`/api/delete_offer/${offer.id}/`);
				}
				this.fetchedClientOffers = this.fetchedClientOffers.filter(
					o => o.id !== offer.id
				);
				if (this.useServerPagination) {
					this.offersTotal = Math.max(0, this.offersTotal - 1);
				}
				this.$emit("location-offers-fetched", this.fetchedClientOffers);
				showAlertModal(
					this.$store,
					"Oferta a fost ștearsă cu succes.",
					"success",
					2000
				);
			} catch (error) {
				console.error(
					"Error deleting offer:",
					error.response ? error.response.data : error.message
				);
				showAlertModal(
					this.$store,
					"A apărut o eroare la ștergerea ofertei.",
					"warning",
					2000,
					error
				);
			} finally {
				this.loading = false;
				this.deleteDialog = false;
			}
		},
		/**
		 * Displays the details of the selected offer.
		 * Redirects to the appropriate route based on the offer type or opens a new tab for unsupported types.
		 *
		 * @async
		 * @function showOfferDetails
		 * @param {Object} item - The offer object containing its details.
		 * @returns {Promise<void>} Navigates to the appropriate route or shows an error if updates fail.
		 */
		async showOfferDetails(item) {
			let offer = item;
			this.$store.state.fetchedClientOffers = this.fetchedClientOffers;

			try {
				// Check for updates before proceeding
				await checkForUpdates(this);

				// Proceed with showing the offer based on its type
				switch (offer.type) {
					case 2:
						this.$router.push({
							name: "OfferPlumbing",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 3:
						this.$router.push({
							name: "OfferVMC",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 4:
						this.$router.push({
							name: "OfferSimple",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 5:
						this.$router.push({
							name: "OfferTechnicalRoom",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 6:
						this.$router.push({
							name: "OfferCeiling",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 7:
						this.$router.push({
							name: "OfferWalls",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 8:
						this.$router.push({
							name: "OfferAutomation",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 9:
						this.$router.push({
							name: "OfferFanCoilUnit",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 10:
						this.$router.push({
							name: "OfferThermalChannel",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 11:
						this.$router.push({
							name: "OfferPDC",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 12:
						this.$router.push({
							name: "OfferVacuum",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 13:
						this.$router.push({
							name: "OfferServices",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId: offer.location.id,
								offerId: offer.id,
							},
						});
						break;
					case 20:
						this.$router.push({
							name: "OfferIPA",
							params: {
								clientId: offer.client.id
									? offer.client.id
									: offer.client,
								locationId:
									offer.location?.id ||
									offer.location_data?.id ||
									offer.location,

								offerId: offer.id,
							},
						});
						break;
					default:
						window.open(
							process.env.VUE_APP_API_BASE_URL +
								`/app/oferta/detaliu/${offer.id}`,
							"_blank"
						);
						break;
				}
			} catch (error) {
				console.error(
					"Error while checking for updates or showing offer details:",
					error
				);
				// You can also show a notification or modal if needed
			}
		},

		async fetchCeilingSetup(offerId) {
			try {
				const response = await apiClient.get(
					`/api/get-ceiling-setup/${offerId}/`
				);
				return response.data;
			} catch (error) {
				if (error.response?.status === 404) {
					console.info("No ceiling setup found for this offer.");
				} else {
					console.error("Error fetching ceiling setup:", error);
				}
				return null;
			}
		},

		async setCeilingArea(offerId) {
			try {
				const ceilingSetup = await this.fetchCeilingSetup(offerId);
				if (ceilingSetup && ceilingSetup.area) {
					this.ceilingSetupAreas[offerId] = ceilingSetup.area;
				} else {
					this.ceilingSetupAreas[offerId] = 0;
				}
			} catch (error) {
				console.error("Error loading ceiling area:", error);
				this.ceilingSetupAreas[offerId] = 0;
			}
		},
		/**
		 * Opens the dimensioning section for the specified offer.
		 * Redirects to the appropriate route based on the offer type.
		 *
		 * @param {Object} offer - The offer object containing its details.
		 */
		openDimensioning(offer) {
			switch (offer.type) {
				case 3:
					this.$router.push({
						name: "OfferVMC",
						params: {
							clientId: offer.client?.id
								? offer.client.id
								: offer.client,
							locationId: offer.location?.id
								? offer.location.id
								: offer.location,
						},
					});
					break;

				case 20:
					this.$router.push({
						name: "OfferIPA",
						params: {
							clientId: offer.client?.id || offer.client,
							locationId:
								offer.location?.id ||
								offer.location_data?.id ||
								offer.location ||
								offer.location_id,
						},
					});
					break;
				case 1:
					this.$router.push({
						name: "OfferIPA",
						params: {
							clientId: offer.client?.id || offer.client,
							locationId:
								offer.location?.id ||
								offer.location_data?.id ||
								offer.location ||
								offer.location_id,
						},
					});
					break;
				default:
					window.open(
						process.env.VUE_APP_API_BASE_URL +
							`/app/client/${
								offer.client?.id
									? offer.client.id
									: offer.client
							}/${
								offer.location?.id
									? offer.location.id
									: offer.location
							}`,
						"_blank"
					);
					break;
			}
		},
	},
};
</script>

<style scoped>
h5 {
	cursor: pointer;
}
</style>
